import { cssVar } from './utils/css';

export const textColor = cssVar('text-color');
export const bodyBackgroundColor = cssVar('body-background-color');
export const containerMaxWidth = cssVar('container-max-width');
export const headlineSizeL = cssVar('headline-size-l');
export const headlineSizeXl = cssVar('headline-size-xl');
export const mainBackgroundColor = cssVar('main-background-color');
export const animationDuration = '0.2s';
export const animationFunction = 'ease-out';
export const animation = `${animationDuration} ${animationFunction}`;
export const inputLabelMarginValue = 23.2;
export const inputLabelMargin = inputLabelMarginValue + 'px';
export const textMSize = cssVar('text-m-size');
export const textXSSize = cssVar('text-xs-size');
export const textMBigSize = cssVar('text-m-big-size');
